import { smooth } from './modules/smooth';
import { outline } from './modules/outline';

// smooth();
outline();
